import React from 'react';
import { connect } from 'react-redux';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import Typography from '@mui/material/Typography';
import { getEquipment } from '../../../redux/selectors/equipment';

const panelStyle = {
  boxShadow: 'none',
};

const overflowStyle = {
  overflowX: 'auto',
};

const EquipmentExpander = ({ equipment, alwaysExpanded, children }) => (
  <Accordion style={panelStyle} expanded={alwaysExpanded} TransitionProps={{ unmountOnExit: true }}>
    {!alwaysExpanded && (
      <AccordionSummary expandIcon="V">
        <Typography>{`${equipment.display.fullName}`}</Typography>
      </AccordionSummary>
    )}
    <AccordionDetails style={overflowStyle}>{children}</AccordionDetails>
  </Accordion>
);

export default connect((state, { equipmentId }) => ({
  equipment: getEquipment(state, equipmentId),
}))(EquipmentExpander);
